import { render, staticRenderFns } from "./Charges.vue?vue&type=template&id=37f90691&scoped=true&"
import script from "./Charges.vue?vue&type=script&lang=js&"
export * from "./Charges.vue?vue&type=script&lang=js&"
import style0 from "./Charges.vue?vue&type=style&index=0&id=37f90691&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f90691",
  null
  
)

export default component.exports